export interface EnrouteApiResponse<B = any> {
  readonly result: ApiResponseResult;
  readonly body: B;
  readonly response?: B;
  readonly error?: string;
  // FIXME: need more info on what comes in meta
  readonly meta: any;
}

export interface JSONRequestResponse<B = any> {
  readonly request: B;
  readonly error?: string;
}

enum ApiResponseResult {
  Ok = 'ok',
  Failure = 'failure',
}

export default ApiResponseResult;
